import { z } from "zod";

import { selectableGuideSchema } from "../selectableGuideSchema";
import { radioStationSchema } from "./radioStationSchema";

export const radioStationDetailsSchema = z.object({
  radio_station: radioStationSchema,
  artists: selectableGuideSchema.array(),
});

export type RadioStationDetails = z.infer<typeof radioStationDetailsSchema>;
